import React, { Component } from 'react'
import PlansSection from '../PlansSection'
//import SubscriptionFeatures from '../SubscriptionFeatures'
import './ChoosePlan.less'
import {pageView} from '../../../common/analytics'

export class ChoosePlan extends Component {
    constructor(props) {
        super(props)
        this.state = {
            categories: []
        }
    }

    onPlanSelect = (selectedPlan) => {
        this.props.onChange(selectedPlan);
        this.props.moveToNextTab(selectedPlan);
    }

    async componentDidMount() {
        pageView('/choosePlan', 'Choose Plan');
    }
    
    render() {
        return <div className='choose-plan-container'>
            <div className='choose-plan-heading'>A Full-Digital Lead Platform To Manage And Grow Your Business</div>
            <div className='choose-plan-sub-heading'>Stop Getting Tired Of Paying For Leads That Don't Convert</div>
            {this.props.plans ? <PlansSection
                plans={this.props.plans}
                onPlanSelect={this.onPlanSelect}
                selectedCategory={this.props.selectedCategory} 
            /> : ''}
            {/*<SubscriptionFeatures />*/}
        </div>
    }
}

export default ChoosePlan;